import * as React from 'react';
import { Typography, TypographyProps, useTheme } from '@mui/material';
import { weights } from '../context';

export interface CerebroTextProps extends Omit<TypographyProps, 'variant' | 'component' | 'ref' | 'fontWeight'> {
	variant?: 'extra-small' | 'small' | 'large' | 'data' | 'hint' | 'error' | 'breadcrumb' | 'cardContentHeading';
	component?: 'p' | 'span';
	weight?: keyof typeof weights;
}

export const CerebroText: React.FC<CerebroTextProps> = ({
	variant = 'large',
	weight = 'regular',
	component = 'p',
	children,
	...props
}) => {
	const theme = useTheme();

	let color = props.color;
	let muiVariant: TypographyProps['variant'] = 'body1';

	switch (variant) {
		case 'extra-small':
			muiVariant = 'body3';
			break;

		case 'small':
			muiVariant = 'body2';
			break;

		case 'large':
			muiVariant = 'body1';
			break;

		case 'data':
			muiVariant = 'data';
			break;

		case 'hint':
			muiVariant = 'hint';
			color = theme.palette.gray.medium;
			break;

		case 'error':
			muiVariant = 'hint';
			color = theme.palette.error.main;
			break;

		case 'breadcrumb':
			muiVariant = 'breadcrumb';
			break;

		case 'cardContentHeading':
			muiVariant = 'cardContentHeading';
			break;
	}

	return (
		<Typography variant={muiVariant} fontWeight={weights[weight]} component={component} {...props} color={color}>
			{children}
		</Typography>
	);
};
